import React, { ReactElement, RefObject, RefCallback } from 'react';
import SelectionInput from './SelectionInput';
import { Checkbox as componentName } from './name';
import Icon from '../Icon/Icon';

export type TCheckbox = {
  /** value of the checkbox dom input*/
  value: string;
  /** The id of the checkbox input, also used on the label as htmlFor */
  id?: string;
  /** Whether or not it is checked */
  isChecked: boolean;
  /** The label text. Also passed into aria-label attribute on the input itself*/
  labelText: string;
  // ** Count of items in a formatted string */
  counter?: string;
  /** Only visible on mobile + stacked */
  icon?: string;
  /** Only visible on mobile + stacked */
  helperText?: string;
  /** On component change */
  onChange?: React.FormEventHandler<HTMLInputElement>;
  className?: string;
  /** External `ref` */
  inputRef?: RefObject<HTMLInputElement> | RefCallback<HTMLInputElement>;
  disabled?: boolean;
} & React.HTMLAttributes<any>;

const CheckMark = () => <Icon name="checkmark" color="background-default" />;

const Checkbox = ({
  value,
  id,
  labelText,
  isChecked,
  counter,
  icon,
  helperText,
  inputRef,
  onChange,
  ...rest
}: TCheckbox): ReactElement => (
  <SelectionInput
    isChecked={isChecked}
    value={value}
    labelText={labelText}
    counter={counter}
    componentName={componentName}
    icon={icon}
    onChange={onChange}
    id={id}
    helperText={helperText}
    CheckMark={CheckMark}
    inputRef={inputRef}
    {...rest}
  />
);

export default Checkbox;
